module.exports = __webpack_public_path__ + "img/spaced-dot.28ca77b5.svg";